// extracted by mini-css-extract-plugin
export default {"notFoundComponent":"notFoundComponent__BkWo5","inner":"inner__apO3G","titleContainer":"titleContainer__GMAM1","title":"title__BmDeR","button":"button___8AR9"};